import { AuthorizationRulesIssues } from "@mmx/shared"

export enum CONFIGURATION_KEYS {

  // Pre-convention keys - do not follow the convention but are still in use
  ACTION_HISTORY_LAST_REPORTED = 'lastActionHistoryReported',
  FUTURE_APPOINTMENT_ELIGIBILITY_ENABLED = 'futureAppointmentEligibilityEnabled',
  FUTURE_APPOINTMENT_ELIGIBILITY_WEEKS = 'futureAppointmentEligibilityWeeks',
  AUTHORIZATION_RULES_ISSUES = 'authorizationRulesIssues',

  // Convention, start with domain, any subdomains, and then the specific configuration
  // In the key, everything is separated by underscore
  // In the value, domain and subdomains are separated by dots and the configuration is in camelCase
  // sorted alphabetically

  // Eligibility
  ELIGIBILITY_ACCEPT_MANAGED_MEDICAID_AS_ACTIVE = 'eligibility.acceptManagedMedicaidAsActive',
  ELIGIBILITY_ACCEPT_MEDICARE_ADVANTAGE = 'eligibility.acceptMedicareAdvantage',
  ELIGIBILITY_MEDICARE_ADVANTAGE_AUTO_INACTIVE = 'eligibility.medicareAdvantageAutoInactive',
  ELIGIBILITY_AUTOMATED_PULL_UPDATES_INSURANCE_DISABLED = 'eligibility.automatedPullUpdatesInsurance',
  ELIGIBILITY_CREATE_APPOINTMENT_FROM_IV_ENABLED = 'eligibility.createAppointmentFromIvEnabled',

  // Clearance
  CLEARANCE_SHOW_AUTH_NOT_SCHEDULED_CPTS = 'clearance.showAuthNotScheduledCpts',
  CLEARANCE_SHOW_ALL_COURSE_OF_CARE_CPTS = 'clearance.showAllCourseOfCareCpts',
  CLEARANCE_AUTH_IGNORE_CPT_MATCH = 'clearance.authIgnoreCptMatch',

  // HL7
  HL7_INSURANCE_STATUS_UPDATES_DISABLED = 'hl7.insuranceStatusUpdatesDisabled',

  // Messaging
  MESSAGING_ALLOW_MANUAL_SEND_CONTACT_EDIT = 'messaging.allowManualSendContactEdit',

  // RamSoft
  RAMSOFT_AUTO_CATEGORIZE_PRODUCTS = 'ramsoft.autoCategorizeProducts',
}

export interface ConfigurationTypeMap {
  //#region Pre convention keys
  [CONFIGURATION_KEYS.ACTION_HISTORY_LAST_REPORTED]: string
  [CONFIGURATION_KEYS.FUTURE_APPOINTMENT_ELIGIBILITY_ENABLED]: boolean
  [CONFIGURATION_KEYS.FUTURE_APPOINTMENT_ELIGIBILITY_WEEKS]: number
  [CONFIGURATION_KEYS.AUTHORIZATION_RULES_ISSUES]: AuthorizationRulesIssues
  //#endregion

  //#region Convention keys
  [CONFIGURATION_KEYS.CLEARANCE_SHOW_AUTH_NOT_SCHEDULED_CPTS]: boolean
  [CONFIGURATION_KEYS.CLEARANCE_SHOW_ALL_COURSE_OF_CARE_CPTS]: boolean
  [CONFIGURATION_KEYS.CLEARANCE_AUTH_IGNORE_CPT_MATCH]: boolean
  [CONFIGURATION_KEYS.ELIGIBILITY_ACCEPT_MANAGED_MEDICAID_AS_ACTIVE]: boolean
  [CONFIGURATION_KEYS.ELIGIBILITY_ACCEPT_MEDICARE_ADVANTAGE]: boolean
  [CONFIGURATION_KEYS.ELIGIBILITY_MEDICARE_ADVANTAGE_AUTO_INACTIVE]: boolean
  [CONFIGURATION_KEYS.ELIGIBILITY_AUTOMATED_PULL_UPDATES_INSURANCE_DISABLED]: boolean
  [CONFIGURATION_KEYS.ELIGIBILITY_CREATE_APPOINTMENT_FROM_IV_ENABLED]: boolean
  [CONFIGURATION_KEYS.HL7_INSURANCE_STATUS_UPDATES_DISABLED]: boolean
  [CONFIGURATION_KEYS.MESSAGING_ALLOW_MANUAL_SEND_CONTACT_EDIT]: boolean
  [CONFIGURATION_KEYS.RAMSOFT_AUTO_CATEGORIZE_PRODUCTS]: boolean
  //#endregion
}

export type Configs = Partial<{[K in CONFIGURATION_KEYS]?: ConfigurationTypeMap[K]}>
